import { render, staticRenderFns } from "./UserApprovalRequestDialog.vue?vue&type=template&id=6adea0e2"
import script from "./UserApprovalRequestDialog.vue?vue&type=script&lang=js"
export * from "./UserApprovalRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports